import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleAuditRGPD() {
  return (
    <BlogArticleLayout
      tag="RGPD"
      title="Audit RGPD en entreprise : comment le réaliser"
      date="5 novembre 2026"
      ctaTitle="Réalisez votre audit RGPD en quelques minutes"
      ctaText="Le diagnostic couvre vos obligations RGPD aux côtés de vos autres référentiels, sans démarche séparée."
    >
      <p style={s.intro}>
        Un audit RGPD ne couvre pas la même chose qu'un audit de cybersécurité technique, même si les deux se
        recoupent partiellement. Il porte sur vos traitements de données, vos bases légales et votre
        documentation, davantage que sur vos systèmes informatiques.
      </p>

      <h2 style={s.h2}>Ce qu'un audit RGPD examine précisément</h2>
      <ul style={s.ul}>
        <li style={s.li}>Votre registre des traitements est-il à jour et complet ?</li>
        <li style={s.li}>Chaque traitement repose-t-il sur une base légale identifiée (consentement, contrat, obligation légale, intérêt légitime) ?</li>
        <li style={s.li}>Vos mentions d'information et votre politique de confidentialité sont-elles à jour et accessibles ?</li>
        <li style={s.li}>Vos contrats avec les prestataires qui traitent des données pour votre compte incluent-ils les clauses de sous-traitance requises ?</li>
        <li style={s.li}>Vos durées de conservation sont-elles définies et respectées dans les faits ?</li>
        <li style={s.li}>Savez-vous répondre à une demande d'exercice de droits dans les délais impartis ?</li>
      </ul>

      <h2 style={s.h2}>Les étapes d'un audit RGPD</h2>
      <p>
        On commence par cartographier l'ensemble des traitements de données de l'entreprise, service par
        service. On vérifie ensuite, pour chacun, la base légale et la conformité des mentions d'information.
        On passe en revue les contrats avec les prestataires impliqués. On contrôle les durées de conservation
        effectivement appliquées. Enfin, on formalise un plan de mise en conformité qui priorise les écarts
        identifiés selon leur niveau de risque.
      </p>

      <h2 style={s.h2}>Audit RGPD et audit cybersécurité : deux angles complémentaires</h2>
      <p>
        Un audit RGPD seul ne suffit pas à couvrir la sécurité technique de vos systèmes, et inversement un
        audit cybersécurité seul ne couvre pas vos obligations documentaires RGPD. C'est pourquoi une approche
        combinée, comme celle décrite dans notre
        {' '}<Link to="/blog/audit-cybersecurite-pme-guide-pratique" style={s.link}>guide pratique de l'audit cybersécurité</Link>,
        évite de traiter ces deux sujets comme des démarches totalement séparées.
      </p>

      <h2 style={s.h2}>Pour aller plus loin</h2>
      <p>
        Notre {' '}<Link to="/blog/rgpd-cybersecurite-ce-que-toute-entreprise-doit-savoir" style={s.link}>guide RGPD</Link>{' '}
        détaille l'ensemble de vos obligations au-delà de l'audit lui-même, et notre article sur la
        {' '}<Link to="/blog/securite-des-donnees-rgpd" style={s.link}>sécurité des données selon le RGPD</Link>{' '}
        approfondit le volet technique.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleAuditRGPD;
